import axios from "axios";

const getUserRegion = () => {
  return sessionStorage.getItem("userRegion") || "AP"; // Default to UK
};

// ✅ Function to get AI Explanation
export const getGenAIExplanation = async (questionText) => {
  try {
    const response = await axios.post(
      "https://ho2reqwzte.execute-api.ap-southeast-2.amazonaws.com/prod/api/explain-question",
      { question: questionText }, 
      {
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(), 
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching GenAI explanation:", error);
    throw error;
  }
};

// ✅ Function to get AI Steps
export const getGenAISteps = async (questionText) => {
  try {
    const response = await axios.post(
      "https://ypti04mxqe.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-steps",
      { question: questionText },
      {
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(), 
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching GenAI steps:", error);
    throw error;
  }
};
